import { isAfter, isValid } from 'date-fns';
import {
  setTimeToDate,
  Meridian,
} from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

interface IsOvernightTimeIntervalProps {
  startTime: string;
  startTimeMeridian: Meridian;
  endTime: string;
  endTimeMeridian: Meridian;
}

export const isOvernightTimeInterval = ({
  startTime,
  startTimeMeridian,
  endTime,
  endTimeMeridian,
}: IsOvernightTimeIntervalProps): boolean => {
  const parsedStartTime = setTimeToDate(
    new Date(),
    startTime,
    startTimeMeridian
  );
  const parsedEndTime = setTimeToDate(new Date(), endTime, endTimeMeridian);

  if (!isValid(parsedStartTime) || !isValid(parsedEndTime)) {
    return false;
  }

  return isAfter(parsedStartTime, parsedEndTime);
};
